import { useTranslation } from 'react-i18next'

export const useSections = () => {
  const { t } = useTranslation()

  const sections = [
    {
      title: t('personal_details'),
      description: t('personal_details_description'),
      fields: [
        {
          label: t('first_name'),
          name: 'first_name',
          rules: [
            {
              required: true,
              message: t('please_input') + ' ' + t('first_name')
            }
          ]
        },
        {
          label: t('last_name'),
          name: 'last_name',
          rules: [
            {
              required: true,
              message: t('please_input') + ' ' + t('last_name')
            }
          ]
        },
        {
          label: t('phone'),
          name: 'phone',
          rules: [
            { required: true, message: t('please_input') + ' ' + t('phone') }
          ]
        },
        {
          label: t('email'),
          name: 'email',
          rules: [
            { required: true, message: t('please_input') + ' ' + t('email') },
            { type: 'email', message: t('invalid_email') }
          ]
        }
      ]
    }
    // {
    //   title: t('address_information'),
    //   description: t('address_information_description'),
    //   fields: [
    //     {
    //       label: t('address'),
    //       name: 'address',
    //       rules: [
    //         { required: true, message: t('please_input') + ' ' + t('address') }
    //       ]
    //     },
    //     {
    //       label: t('town_city'),
    //       name: 'city',
    //       rules: [
    //         {
    //           required: true,
    //           message: t('please_input') + ' ' + t('town_city')
    //         }
    //       ]
    //     },
    //     {
    //       label: t('country_state'),
    //       name: 'country',
    //       rules: [
    //         {
    //           required: true,
    //           message: t('please_input') + ' ' + t('country_state')
    //         }
    //       ]
    //     },
    //     {
    //       label: t('postal_code'),
    //       name: 'postal_code',
    //       rules: [
    //         {
    //           required: true,
    //           message: t('please_input') + ' ' + t('postal_code')
    //         }
    //       ]
    //     }
    //   ]
    // }
  ]

  return { sections }
}
